// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meEndpoint: '/auth/me',
  storageTokenKeyName: 'beemz-finance-accessToken',
  storageRefreshTokenKeyName: 'beemz-finance-refreshToken',
  storageUserDataKeyName: 'beemz-finance-userData',
}
